<template>
  <div class="print__info">
    <!--    <img :src="manager.url" :alt="manager.name" />-->
    <!--    <p>-->
    <!--      <b>{{ manager.position }}</b>-->
    <!--    </p>-->
    <!--    <h3>{{ manager.name }}</h3>-->
    <!--    <p>-->
    <!--      <b v-for="item in manager.phone.split(',')" :key="item">-->
    <!--        {{ item }}-->
    <!--        <br />-->
    <!--      </b>-->
    <!--    </p>-->
    <!--    <p>-->
    <!--      <b>{{ manager.email }}</b>-->
    <!--    </p>-->

    <button class="print__btn btn" type="button" @click="print">
      Печать
    </button>
    &nbsp;
    <button class="print__btn btn" type="button" @click="back">
      Назад
    </button>
  </div>
</template>

<script>
export default {
  name: "Print-manager",
  computed: {
    manager() {
      return this.$store.getters.manager;
    }
  },
  methods: {
    print() {
      setTimeout(() => {
        window.print();
      }, 1);
    },
    back() {
      // this.$router.push({ name: "Page" });
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.print__info {
  margin: auto;
}
</style>
